import { notification } from 'antd';
import actions from './actions';
import { DataService } from '../../../config/dataService/dataService';

const GENERIC_API_ERROR = process.env.REACT_APP_GENERIC_ERROR_MESSAGE;

const {
  empresasList,
  empresasListSelectBox,
  empresasCreate,
  empresasRead,
  empresasUpdate,
  empresasDelete,  
} = actions;

const empresasListAction = (paramBusqueda = '') => {
  return async dispatch => {
    try {
      const response = await DataService.get('/empresas/list.php?paramBusqueda=' + paramBusqueda);      
      
      if (response.status === 200 && response.data.data) {       
        dispatch(empresasList(response.data.data));
        return true
      }
      return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};


const empresasCreateAction = data => {
  return async dispatch => {
    try {
      const response = await DataService.post('/empresas/manage.php', data);
      if (response.status === 200) return true;
      else return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

const empresasReadAction = (id = '') => {
  return async dispatch => {
    try {
      if (id != '') {
        const response = await DataService.get('/empresas/manage.php?id=' + id);
        if (response.status === 200 && response.data.data) {
          dispatch(empresasRead(response.data.data));
          return true;
        }
      } else {
        dispatch(empresasRead({}));
      }
      return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

/////////////////

export {
  empresasListAction,
  empresasCreateAction,
  empresasReadAction,    
};
